import React, { useState } from "react";
import {
  Table,
  Form,
  Pagination,
  Container,
  Row,
  Col,
  Button,
  Card,
} from "react-bootstrap";
import "./css/BookingView.css";
import { FiEdit } from "react-icons/fi";
import { RiDeleteBin6Line } from "react-icons/ri"
// Sample order data
const ordersData = [
  {
    id: 1,
    orderNo: "ODHCO72",
    customer: "Kunal Datta",
    contact: "09674974221",
    details: "2 BHK Flat Cleaning",
    vendor: "",
    serviceDate: "25-01-2020",
    serviceTime: "10:30 am",
    servicePlace:
      "Flat no A2, 2nd Floor, 2660, Pelican Twins, Nayabad, PO Mukundapur near Nayabad Mini bus stand, West Bengal,KOLKATA-700033",
  },
  {
    id: 2,
    orderNo: "ODHCO71",
    customer: "Olivia",
    contact: "9831306561",
    details: "Baby Care",
    vendor: "",
    serviceDate: "01-02-2020",
    serviceTime: "07:48 am",
    servicePlace:
      "Pathak bagan vivekananda road near DI office, West Bengal,Hooghly -712103",
  },
  {
    id: 3,
    orderNo: "ODHCO70",
    customer: "ARINDAM DUTTA",
    contact: "8652652156",
    details: "Book your Plumber Service",
    vendor: "",
    serviceDate: "22-11-2019",
    serviceTime: "09:42 am",
    servicePlace:
      "Kamar Para Road Near Nutan Bazar Gate near Opposite Music Center shop, West Bengal,Hooghly-712101",
  },

  {
    id: 4,
    orderNo: "ODHCO70",
    customer: "ARINDAM DUTTA",
    contact: "8652652156",
    details: "Book your Plumber Service",
    vendor: "",
    serviceDate: "22-11-2019",
    serviceTime: "09:42 am",
    servicePlace:
      "Kamar Para Road Near Nutan Bazar Gate near Opposite Music Center shop, West Bengal,Hooghly-712101",
  },

  {
    id: 5,
    orderNo: "ODHCO70",
    customer: "ARINDAM DUTTA",
    contact: "8652652156",
    details: "Book your Plumber Service",
    vendor: "",
    serviceDate: "22-11-2019",
    serviceTime: "09:42 am",
    servicePlace:
      "Kamar Para Road Near Nutan Bazar Gate near Opposite Music Center shop, West Bengal,Hooghly-712101",
  },

  {
    id: 6,
    orderNo: "ODHCO70",
    customer: "ARINDAM DUTTA",
    contact: "8652652156",
    details: "Book your Plumber Service",
    vendor: "",
    serviceDate: "22-11-2019",
    serviceTime: "09:42 am",
    servicePlace:
      "Kamar Para Road Near Nutan Bazar Gate near Opposite Music Center shop, West Bengal,Hooghly-712101",
  },
  {
    id: 7,
    orderNo: "ODHCO70",
    customer: "ARINDAM DUTTA",
    contact: "8652652156",
    details: "Book your Plumber Service",
    vendor: "",
    serviceDate: "22-11-2019",
    serviceTime: "09:42 am",
    servicePlace:
      "Kamar Para Road Near Nutan Bazar Gate near Opposite Music Center shop, West Bengal,Hooghly-712101",
  },
  {
    id: 8,
    orderNo: "ODHCO70",
    customer: "ARINDAM DUTTA",
    contact: "8652652156",
    details: "Book your Plumber Service",
    vendor: "",
    serviceDate: "22-11-2019",
    serviceTime: "09:42 am",
    servicePlace:
      "Kamar Para Road Near Nutan Bazar Gate near Opposite Music Center shop, West Bengal,Hooghly-712101",
  },
  {
    id: 9,
    orderNo: "ODHCO70",
    customer: "ARINDAM DUTTA",
    contact: "8652652156",
    details: "Book your Plumber Service",
    vendor: "",
    serviceDate: "22-11-2019",
    serviceTime: "09:42 am",
    servicePlace:
      "Kamar Para Road Near Nutan Bazar Gate near Opposite Music Center shop, West Bengal,Hooghly-712101",
  },
  {
    id: 10,
    orderNo: "ODHCO70",
    customer: "ARINDAM DUTTA",
    contact: "8652652156",
    details: "Book your Plumber Service",
    vendor: "",
    serviceDate: "22-11-2019",
    serviceTime: "09:42 am",
    servicePlace:
      "Kamar Para Road Near Nutan Bazar Gate near Opposite Music Center shop, West Bengal,Hooghly-712101",
  },
  {
    id: 11,
    orderNo: "ODHCO70",
    customer: "ARINDAM DUTTA",
    contact: "8652652156",
    details: "Book your Plumber Service",
    vendor: "",
    serviceDate: "22-11-2019",
    serviceTime: "09:42 am",
    servicePlace:
      "Kamar Para Road Near Nutan Bazar Gate near Opposite Music Center shop, West Bengal,Hooghly-712101",
  },
  {
    id: 12,
    orderNo: "ODHCO70",
    customer: "ARINDAM DUTTA",
    contact: "8652652156",
    details: "Book your Plumber Service",
    vendor: "",
    serviceDate: "22-11-2019",
    serviceTime: "09:42 am",
    servicePlace:
      "Kamar Para Road Near Nutan Bazar Gate near Opposite Music Center shop, West Bengal,Hooghly-712101",
  },
  {
    id: 13,
    orderNo: "ODHCO70",
    customer: "ARINDAM DUTTA",
    contact: "8652652156",
    details: "Book your Plumber Service",
    vendor: "",
    serviceDate: "22-11-2019",
    serviceTime: "09:42 am",
    servicePlace:
      "Kamar Para Road Near Nutan Bazar Gate near Opposite Music Center shop, West Bengal,Hooghly-712101",
  },

  {
    id: 14,
    orderNo: "ODHCO70",
    customer: "ARINDAM DUTTA",
    contact: "8652652156",
    details: "Book your Plumber Service",
    vendor: "",
    serviceDate: "22-11-2019",
    serviceTime: "09:42 am",
    servicePlace:
      "Kamar Para Road Near Nutan Bazar Gate near Opposite Music Center shop, West Bengal,Hooghly-712101",
  },
  // Add more orders as needed
];

const ITEMS_PER_PAGE = 10;

export default function BookingView() {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const filteredOrders = ordersData.filter(
    (o) =>
      o.orderNo.toLowerCase().includes(search.toLowerCase()) ||
      o.customer.toLowerCase().includes(search.toLowerCase()) ||
      o.details.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filteredOrders.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentOrders = filteredOrders.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );

  const handlePageChange = (page) => setCurrentPage(page);
const handleAssign = (id) => {
  alert(`Assign vendor for Order ID: ${id}`);
};

const handleEdit = (id) => {
  alert(`Edit Order ID: ${id}`);
};

const handleDelete = (id) => {
  if (window.confirm('Are you sure you want to delete this order?')) {
    alert(`Deleted Order ID: ${id}`);
    // Implement delete logic here
  }
};

  return (
    <Container fluid className="booking-view-container">
      <div className="order-header" style={{ marginTop: 20 }}>
        <h2>Manage Bookings</h2>
        <Form.Control
          type="text"
          placeholder="Search by Order No, Customer, or Details"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="table-container" style={{ marginTop: 10 }}>
        <Table bordered hover responsive className="order-table">
  <thead className="custom-thead">
    <tr>
      <th>Sl No.</th>
      <th>Order No</th>
      <th>Customer</th>
      <th>Contact</th>
      <th>Order Details</th>
      <th>Vendor</th>
      <th>Service Date/Time</th>
      <th>Service Place</th>
      <th>Action</th> {/* New Action column */}
    </tr>
  </thead>
  <tbody>
    {currentOrders.length ? (
      currentOrders.map((o, idx) => (
        <tr key={o.id} className={idx % 2 === 0 ? "even-row" : "odd-row"}>
          <td>{startIndex + idx + 1}</td>
          <td>{o.orderNo}</td>
          <td>{o.customer}</td>
          <td>[{o.contact}]</td>
          <td>{o.details}</td>
          <td>
            <Form.Select>
              <option>Choose Vendor</option>
            </Form.Select>
            <center>
              <button
                className="assign-btn"
                onClick={() => handleAssign(o.id)}
              >
                Assign Vendor
              </button>
            </center>
          </td>
          <td>{o.serviceDate} {o.serviceTime}</td>
          <td>{o.servicePlace}</td>
          <td>
            <Button
                variant="outline-primary"
                      size="sm"
                      className="me-2"
              onClick={() => handleEdit(o.id)}
            >
            <FiEdit/>
            </Button>
            <Button
              variant="outline-danger"
                      size="sm"
              onClick={() => handleDelete(o.id)}
            >
              <RiDeleteBin6Line/>
            </Button>
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="9" className="text-center">No orders found</td>
      </tr>
    )}
  </tbody>
</Table>
      </div>
      <br />
      <Pagination className="justify-content-center">
        <Pagination.First
          onClick={() => handlePageChange(1)}
          disabled={currentPage === 1}
        />
        <Pagination.Prev
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        />
        {[...Array(totalPages)].map((_, idx) => (
          <Pagination.Item
            key={idx + 1}
            active={currentPage === idx + 1}
            onClick={() => handlePageChange(idx + 1)}
            style={{ color: "#000" }}
          >
            {idx + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        />
        <Pagination.Last
          onClick={() => handlePageChange(totalPages)}
          disabled={currentPage === totalPages}
        />
      </Pagination>
    </Container>
  );
}
